import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Portfolio from "@/components/site/Portfolio";
import FeaturedInstall from "@/components/site/FeaturedInstall";
import FAQ from "@/components/site/FAQ";
import BookingForm from "@/components/site/BookingForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-bone text-text-main">
      <Nav />
      <main>
        <Hero />
        <Services />
        <Process />
        <Portfolio />
        <FeaturedInstall />
        <BookingForm />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
